module.exports = __webpack_public_path__ + "static/media/reorder.0b90fec9.png";